export interface ReCaptchaStatus {
  completed?: boolean;
  expired?: boolean;
  failed?: boolean;
  token?: string;
}
